import { z } from 'zod';

export interface VisitDocumentApi {
  id: string;
  visitId: string;
  documentUrl: string;
  description: string;
  documentType: 'PHOTO' | 'SIGNATURE';
  createdAt: string;
  updatedAt: string;
}

export interface VisitApi {
  id: string;
  routeId: string;
  scheduledFrom: string;
  scheduledTo: string;
  visitedAt: string | null;
  lat: number;
  long: number;
  visitedLat?: number;
  visitedLong?: number;
  status: string;
  shippingNumber: string;
  order: string;
  type: string;
  /** @deprecated Read the receiver document from deliveryReceipt instead. */
  documentNumber?: string | null;
  deliveryReceipt?: {
    receiver: {
      name: string | null;
      documentNumber: string | null;
    };
  };
  shippings?: Array<{
    number: number;
    status: string;
  }>;
  recipient: string;
  commerceName?: string;
  createdAt: string;
  updatedAt: string;
  visitDocuments?: VisitDocumentApi[];
  pickedCount?: number;
}

export const visitDocumentSchema = z.object({
  id: z.string(),
  visitId: z.string(),
  documentUrl: z.string(),
  description: z.string(),
  documentType: z.enum(['PHOTO', 'SIGNATURE']),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const visitSchema = z.object({
  id: z.string(),
  routeId: z.string(),
  scheduledFrom: z.string(),
  scheduledTo: z.string(),
  visitedAt: z.string().nullable(),
  lat: z.number(),
  long: z.number(),
  status: z.string(),
  shippingNumber: z.string(),
  order: z.string(),
  type: z.string(),
  documentNumber: z.string().nullable().optional(),
  deliveryReceipt: z
    .object({
      receiver: z.object({
        name: z.string().nullable(),
        documentNumber: z.string().nullable(),
      }),
    })
    .optional(),
  shippings: z
    .array(z.object({ number: z.number(), status: z.string() }))
    .optional(),
  recipient: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  visitDocuments: z.array(visitDocumentSchema).optional(),
});

export type VisitSchema = z.infer<typeof visitSchema>;
export type VisitDocumentSchema = z.infer<typeof visitDocumentSchema>;
